var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarUserSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.28 -486.41)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.78,486.41c1.02,0,1.93.41,2.6,1.08.67.67,1.08,1.6,1.08,2.62s-.41,1.93-1.08,2.6c-.3.32-.65.55-1.04.75,1.04.28,1.99.83,2.74,1.58,1.1,1.1,1.79,2.62,1.79,4.3v.73c0,.37-.16.71-.39.95-.24.26-.59.39-.95.39h-9.5c-.37,0-.71-.14-.95-.39-.26-.24-.39-.57-.39-.95v-.73c0-1.68.69-3.19,1.79-4.3.73-.75,1.68-1.3,2.72-1.58-.37-.2-.75-.43-1.04-.75-.67-.67-1.08-1.6-1.08-2.6s.41-1.95,1.08-2.62c.67-.67,1.6-1.08,2.62-1.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUserSettings);
export default __webpack_public_path__ + "static/media/sidebar_user_settings.1b1924c85500bcb7231c2436be814b9f.svg";
export { ForwardRef as ReactComponent };